import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CustomCalendar = ({ formData, setFormData }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Convert stored date string (DD-MM-YYYY) to Date object safely
  const parseDate = (dateStr) => {
    if (!dateStr) return null;
    const [day, month, year] = dateStr.split("-");
    return new Date(`${year}-${month}-${day}`); // Ensure correct format for Date()
  };

  return (
    <div className="relative w-[18.5rem] md:w-full">
      {/* Input box that opens the date picker */}
      <input
        type="text"
        name="tableDate"
        placeholder="Select a date"
        value={formData?.tableDate}
        onFocus={() => setIsOpen(true)}
        className="w-full p-2 border rounded-xl mt-2 h-12 text-black placeholder-gray-500"
        readOnly
      />

      {/* Custom-styled DatePicker */}
      {isOpen && (
        <div className="absolute top-14 left-0 z-50 bg-white shadow-lg border rounded-2xl p-2">
          <DatePicker
            selected={parseDate(formData.tableDate)}
            onChange={(date) => {
              setIsOpen(false);
              if (!date) return;

              // Format date as "DD-MM-YYYY"
              const formattedDate = date
                .toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })
                .replace(/\//g, "-");

              console.log("Formatted Date:", formattedDate);
              setFormData((prev) => ({
                ...prev,
                tableDate: formattedDate, // Store as a string
              }));
              console.log(formData);
            }}
            minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
            inline
            calendarClassName="custom-calendar"
          />
        </div>
      )}

      {/* Custom Styles */}
      <style>{`
        .custom-calendar {
          border: none;
        }
        .react-datepicker__header {
          color: black;
          border-bottom: none;
        }
        .react-datepicker__day--selected,
        .react-datepicker__day--keyboard-selected {
          background-color: #FFD700 !important;
          color: black !important;
          border-radius: 50%;
        }
        .react-datepicker__day:hover {
          background-color: #FFECB3 !important;
        }
      `}</style>
    </div>
  );
};

export default CustomCalendar;
